import { useCallback, useEffect } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import { useHasAccessToOrderForm } from 'services/repositories/orderForms/orderForms';
import { OrderFormsRoutes } from 'support/types';

export function useRedirectAuthorizedToOrderForm() {
  const navigate = useNavigate();
  const params = useParams<{ supplierSlug: string }>();

  const redirectToOrderFormsRoot = useCallback(() => {
    const orderFormRoute = generatePath(OrderFormsRoutes.root, {
      supplierSlug: params.supplierSlug || '',
    });

    navigate(orderFormRoute, {
      replace: true,
    });
  }, [navigate, params.supplierSlug]);
  const { isSuccess: canAccessOrderForm, isLoading } = useHasAccessToOrderForm({
    variables: { supplierSlugName: params.supplierSlug },
    retry: false,
  });

  useEffect(() => {
    if (canAccessOrderForm) {
      redirectToOrderFormsRoot();
    }
  }, [canAccessOrderForm, redirectToOrderFormsRoot]);

  return { isLoading };
}
